import { IconButton, InputBase, Menu, MenuItem, Toolbar } from "@mui/material";
import React, { useState } from "react";
import { MoreHoriz as MoreHorizIcon } from "@mui/icons-material";

function Header({
  search,
  onSearchChange,
  setShowProgressDialog,
  readOnly,
}: {
  search: string;
  onSearchChange: (newSearch: string) => void;
  setShowProgressDialog: (show: boolean) => void;
  readOnly?: boolean;
}) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  return (
    <Toolbar disableGutters sx={{ padding: 1 }}>
      <InputBase
        size="small"
        fullWidth
        placeholder="Search…"
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        sx={{
          backgroundColor: "whitesmoke",
          borderRadius: "999px",
          padding: "8px 16px",
        }}
      />
      {!readOnly && (
        <>
          <IconButton
            aria-label="More"
            color="inherit"
            sx={{ marginLeft: 0.5 }}
            onClick={(e) => setAnchorEl(e.currentTarget)}
          >
            <MoreHorizIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
          >
            <MenuItem>View as</MenuItem>
            <MenuItem>Sort by</MenuItem>
            <MenuItem
              onClick={() => {
                setAnchorEl(null);
                setShowProgressDialog(true);
              }}
            >
              Progress
            </MenuItem>
          </Menu>
        </>
      )}
    </Toolbar>
  );
}

export default Header;
